// Should already be required, here for clarity
require('angular');

// Load Angular and dependent libs
require('angular-animate');
require('angular-aria');

// Now load Angular Material
require('./angular-material');

// Export namespace
module.exports = 'ngMaterial';



//////////////////
// WEBPACK FOOTER
// ./~/angular-material/index.js
// module id = 195
// module chunks = 1